import React from 'react';
import './styles.css';

interface Props {
  message: string;
  visible: boolean;
  setVisible: (value: boolean) => void;
  autoDisappear?: boolean;
  setAfterSnackbar?: (value: boolean) => void;
}

export const Snackbar = (props: Props) => {
  if (props.autoDisappear) setTimeout(() => {
    props.setVisible(false)
    
  }, 3000);
  if (props.setAfterSnackbar) props.setAfterSnackbar(true);

  return (
    <div className={`snackbar ${props.visible && 'show'}`}>
      {props.message}
      <i onClick={() => props.setVisible(false)} className='fa fa-times snackbar__quit-icon'></i>
    </div>

  );
};
